"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSelectTagsInputContainer = exports.StyledTagsSelectTextInput = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var globalVariables_1 = require("../../../../../globalStyles/globalVariables");
var mixins_1 = require("../../../../../themes/mixins");
var themes_1 = require("../../../../themes");
exports.StyledTagsSelectTextInput = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  border: 0;\n  width: 100%;\n  background-color: ", ";\n  \n  // this strange bit is to fix the 'zoom into input' issue on ios\n  margin: 0 -2rem;\n  ", "\n  &:focus {\n    border: 0;\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  height: 100%;\n  border: 0;\n  width: 100%;\n  background-color: ", ";\n  \n  // this strange bit is to fix the 'zoom into input' issue on ios\n  margin: 0 -2rem;\n  ", "\n  &:focus {\n    border: 0;\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), themes_1.colors.none, globalVariables_1.globalInputElemPadding, themes_1.colors.grey40);
exports.StyledSelectTagsInputContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  position: relative;\n  border-radius: 2px;\n  background-color: ", ";\n  padding: 1rem 2rem 1rem 2rem;\n  ", "\n\n  ", ";\n\n  ", "\n  ", "\n\n  height: auto;\n  align-items: flex-start;\n"], ["\n  cursor: pointer;\n  position: relative;\n  border-radius: 2px;\n  background-color: ", ";\n  padding: 1rem 2rem 1rem 2rem;\n  ", "\n\n  ", ";\n\n  ", "\n  ", "\n\n  height: auto;\n  align-items: flex-start;\n"])), themes_1.colors.grey5, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      pointer-events: none;\n    "], ["\n      pointer-events: none;\n    "])));
}, (0, mixins_1.transition)("background-color"), globalVariables_1.globalInputElemFocused, globalVariables_1.globalInputElemHover);
var templateObject_1, templateObject_2, templateObject_3;
